import "../parts/video-pagination";

import {SuperAlign} from "../class/SuperAlign";
const superAlign = new SuperAlign('.js-text-normalize-videos');

if(window.innerWidth >= 576){
  superAlign.init();
}

